import React, { useState, useEffect } from 'react';
import axios from 'utils/axios';
import { Link, useNavigate } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Pagination from 'components/Pagination';
import { MdAddCircle } from 'react-icons/md';
import { Button } from 'react-bootstrap';

const Users = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const itemsPerPage = 10;

  const fetchUsers = async (page) => {
    try {
      const response = await axios.get('users', {
        params: {
          page,
          count: itemsPerPage
        }
      });

      setUsers(response.data.items);
      setTotalPages(Math.ceil(response.data.total / itemsPerPage));
      setLoading(false);
    } catch (err) {
      toast.error(t('failed_to_fetch_users'));
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage);
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  if (loading) return <div>{t('loading')}...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3 mt-5">
        <h2>{t('users_list')}</h2>
        <Button variant="primary" onClick={() => navigate('/adduser')}>
          <MdAddCircle className="me-2" size={20} />
          {t('add_user')}
        </Button>
      </div>

      <table className="table w-full text-sm text-left border-collapse">
        <thead className="border-b">
          <tr>
            <th>{t('username')}</th>
            <th>{t('name')}</th>
            <th>{t('surname')}</th>
            <th>{t('email')}</th>
            <th>{t('roles')}</th>
            <th>{t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="border-b hover:bg-gray-50">
              <td>{user.username}</td>
              <td>{user.name}</td>
              <td>{user.surname}</td>
              <td>{user.email}</td>
              <td>
                {Array.isArray(user.roles)
                  ? user.roles.map((r) => r.role || r).join(', ')
                  : user.roles}
              </td>
              <td>
              <Link to={`/users/${user.username}`}>{t('edit')}</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>


      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
        loading={loading}
      />
    </div>
  );
};

export default Users;
